export function uid(radix?: number) {
  const r = radix || 32;
  return Math.round(Math.random() * r ** 12).toString(r);
}
